<div class="table-responsive">
  <table id='tableCmp' #tableCmp class="table tablestuff">
    <thead>
      <tr>
        <th *ngFor="let c of _columnDefinitions;let last=last;" [attr.width]="c.WidthPixels" class="report-cell" [ngStyle]="{'border-right-width': (last) ? 0 : 1}">
          <div class="report-cell-content" [attr.align]="(c?.Alignment === _alignTypes.Center) ? 'center' : (c?.Alignment === _alignTypes.Right) ? 'right' : 'left'">
            {{c.Title}}
          </div>
          <app-dropdown *ngIf="last && data.HasActions" type="cluster" [actions]="clusterActions"></app-dropdown>
        </th>
        <th class="report-cell"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of _rows; let i = index; " class="table-results" [ngClass]="{'d-none': (displayBtnShowMore && i >= rowsPerPage)}">
        <td *ngFor="let c of row.Values; let last = last; let i = index;"
          [class]="'report-cell-content ' + row.ElementID"
          [ngStyle]="{'text-align': (_columnDefinitions[i]?.Alignment === _alignTypes.Center) ? 'center' : (_columnDefinitions[i]?.Alignment === _alignTypes.Right) ? 'right' : 'left'}">
          {{c}}
        </td>
        
        <td *ngFor="let col of row.CustomCols; let z = index;" class="{{row.ElementID}} position-relative" [ngStyle]="{'text-align': (_columnDefinitions[z]?.Alignment === _alignTypes.Center) ? 'center' : (_columnDefinitions[z]?.Alignment === _alignTypes.Right) ? 'right' : 'left'}">
          <div [innerHTML]="(col && col.html) ? col.html : col" >
            {{col}}
          </div>
        </td>
        
        <td class="report-cell-content actions text-right" width="10" id="table-dropdown-{{i}}" *ngIf="!deleteBtnRoute">
          <a id="table-item-{{i}}" class="btn-actions" (click)="getElementActions(row.ElementID, $event)" *ngIf="row.HasActions">
            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
          </a>
        </td>
       
        <td class="report-cell-content actions text-right" width="10" id="table-dropdown-{{i}}" *ngIf="deleteBtnRoute || editBtnRoute || customBtnRoute">
          <div class="position-relative text-right mt-2">
            <button *ngIf="editBtnRoute" id="table-btn-edit-{{i}}" type="button"
              class="btn btn-link p-1" [ngClass]="{'mr-1': downloadBtnRoute}" tooltip="{{_appService.CoreCommonLiterals.Edit}}"
              (click)="editElement(row.ElementID)" placement="left">
              <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
            </button>
            <button *ngIf="downloadBtnRoute"  id="table-btn-download-{{i}}" type="button"
            class="btn btn-link p-1 mr-1" tooltip="{{_appService.CoreCommonLiterals.Download}}"
            (click)="downloadElement(row.ElementID)" placement="left">
            <i class="fa-solid fa-download" aria-hidden="true"></i>
          </button>
            <button *ngIf="deleteBtnRoute" [ngClass]="{'d-none': row.HiddeDeleteButton}" id="table-btn-trash-{{i}}" type="button"
              class="btn btn-link text-danger p-1" [tooltip]="deleteBtnTooltip ? deleteBtnTooltip : _appService.CoreCommonLiterals.Delete"
              (click)="removeElement(row.ElementID)" placement="left" [disabled]="disableDeleteBtn">
              <i aria-hidden="true" [class]="deleteBtnIcon ? deleteBtnIcon : 'fa fa-trash-alt'"></i>
            </button>
            <button *ngIf="customBtnRoute" id="table-btn-custom-{{i}}" type="button"
            class="btn btn-link p-1" [tooltip]="customBtnTooltip ? customBtnTooltip : ''"
            (click)="actionElement(row.ElementID)" placement="left">
            <i aria-hidden="true" class="fa-solid" [class]="customBtnIcon ? customBtnIcon : ''"></i>
          </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <button *ngIf="displayBtnShowMore && data && _rows && _rows.length && _rows.length > rowsPerPage"
  class="btn expand-button btn-secondary btn-block my-2" 
  (click)="showMoreElements($event)" 
  style="font-weight: 600; border: 1px solid #d1d0d0;">
    {{_appService.CoreCommonLiterals.SeeMoreButton}}
  </button>
  <div class="text-center my-2" *ngIf="data && _rows && _rows.length === 0 && !loadData">
    <i class="fa fa-file-alt text-primary" [class]="customIconSize ? customIconSize : 'fa-4x'"></i>
    <p class="h5 text-muted my-2">{{noneDataMessage ? noneDataMessage : _appService.CoreCommonLiterals.NoDataFound}}</p>
  </div>
</div>
<div class="text-center d-flex align-items-center w-100 justify-content-center" *ngIf="_rows === null || loadData" style="min-height: 100px;">
  <i class="fas fa-circle-notch fa-spin fa-2x"></i>
</div>

<div class="d-flex justify-content-sm-end align-items-center my-2 overflow-auto flex-column flex-sm-row" *ngIf="enablePagination &&  _rows?.length && _totalPageCount > 1">
  <button
    id="reports-btn-start"
    [disabled]="_PreviousHidden"
    type="button"
    class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0"
    (click)="movePage(-1, true)">
    <span>&lsaquo;</span> {{_appService.CoreCommonLiterals.FirstPage }}
  </button>
  <button
    id="reports-btn-previous"
    [disabled]="_PreviousHidden"
    type="button"
    class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0"
    (click)="movePage(-1)">
    <span>&laquo;</span> {{_appService.CoreCommonLiterals.PreviousPage }}
  </button>
  <span class="mx-2 text-nowrap mb-2 mb-sm-0" *ngIf="_totalPageCount > 1">
    {{ _currentPageNumber }} / {{ _totalPageCount }}
  </span>
  <button
    id="reports-btn-next"
    [disabled]="_NextHidden"
    type="button"
    class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0"
    (click)="movePage(1)">
    {{ _appService.CoreCommonLiterals.NextPage }} <span>&raquo;</span>
  </button>
  <button
    id="reports-btn-last"
    [disabled]="_NextHidden"
    type="button"
    class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0"
    (click)="movePage(1, true)">
    {{ _appService.CoreCommonLiterals.LastPage }} <span>&rsaquo;</span>
  </button>
  <span class="mx-2 text-nowrap" *ngIf="showTotalRowCount">
    {{ _appService.CoreCommonLiterals.TotalRowCount + ': ' + _totalRowCount }}
  </span>
</div>